import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ProjectComponent } from './project/project.component';

import { ProjectsModule } from '../projects/projects.module';
import { TimelineComponent } from './timeline/timeline.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent, data: {animation: 'HomePage'} },
  { 
    path: 'timeline', 
    component: ProjectComponent, 
    children: [{
      path: '',
      component: TimelineComponent}
    ], 
    data: {animation: 'TimelinePage'} 
  },
  //{ path: 'project', component: ProjectComponent, data: {animation: 'Project'} },
  { path: 'project', loadChildren: () => import('../projects/projects.module').then(m => m.ProjectsModule), component: ProjectComponent, data: {animation: 'Project'} },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
